import React, { useState, useEffect } from 'react';
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
import { AgGridReact } from 'ag-grid-react';
import axios from 'axios';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const HomeSlider = () => {
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null); // New state for image preview
  const [clickUrl, setClickUrl] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [rowData, setRowData] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [type, setType] = useState('');

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file)); // Set image preview
    }
  };

  const handleUrlChange = (e) => setClickUrl(e.target.value);
  const handleStartDateChange = (e) => setStartDate(e.target.value);
  const handleEndDateChange = (e) => setEndDate(e.target.value);
  const handleTypeChange = (e) => setType(e.target.value);

  const fetchSliderData = () => {
    axios.get(`${API_BASE_URL}/api/homeslider_new_data`)
      .then(response => {
        setRowData(response.data);
      })
      .catch(error => console.error("Error fetching slider data:", error));
  };

  useEffect(() => {
    fetchSliderData();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    if (image instanceof File) {
      formData.append("image", image);
    }

    formData.append("clickUrl", clickUrl);
    formData.append("startDate", startDate);
    formData.append("endDate", endDate);
    formData.append("type", type);
    const loggedInUser = localStorage.getItem("username");
    formData.append("cby", loggedInUser);

    try {
      let response;
      if (editingId) {
        response = await fetch(`${API_BASE_URL}/api/homeslider_update/${editingId}`, {
          method: "PUT",
          body: formData,
        });
      } else {
        response = await fetch(`${API_BASE_URL}/api/homeslider_new`, {
          method: "POST",
          body: formData,
        });
      }
      
      const data = await response.json();
      console.log("Response:", data);
      
      if (response.ok) {
        window.location.reload();
      } else {
        console.error("Error response from server:", data);
      }

    } catch (error) {
      console.error("Error saving home slider data:", error);
    }
  };

  const handleViewClick = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  const handleEditClick = (rowData) => {
    setClickUrl(rowData.click_url);
    setStartDate(formatDateForInput(rowData.start_date));
    setEndDate(formatDateForInput(rowData.end_date));
    setEditingId(rowData.id);
    setImagePreview(rowData.image_url); // Set image preview
    setImage(null); // Reset image file
    setType(rowData.type);
  };

  const formatDateForInput = (dateString) => {
    if (!dateString || dateString === "00/00/0000") return "";
    const [day, month, year] = dateString.split("/");
    return `${year}-${month}-${day}`;
  };

  const handleDeleteClick = async (id) => {
    if (!id) {
      alert("Invalid record ID!");
      return;
    }

    if (window.confirm("Are you sure you want to delete this record?")) {
      try {
        const response = await fetch(`${API_BASE_URL}/api/homeslider_delete/${id}`, {
          method: "DELETE",
        });

        const data = await response.json();
        console.log("Delete Response:", data);

        if (response.ok) {
          fetchSliderData();
        } else {
          console.error("Error deleting record:", data);
        }
      } catch (error) {
        console.error("Error deleting home slider record:", error);
      }
    }
  };

  const columnDefs = [
    { headerName: "S.No", valueGetter: (params) => params.node.rowIndex + 1, flex: 0.5 },
    {
      headerName: "Image",
      field: "image_url",
      flex: 1,
      cellRenderer: (params) => (
        <img src={params.value} alt="Slider" style={{ width: "100px", height: "auto" }} />
      ),
    },
    {
      headerName: "Click URL",
      field: "click_url",
      flex: 1,
      cellRenderer: (params) => (
        <button
          onClick={() => handleViewClick(params.value)}
          className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
        >
          View
        </button>
      ),
    },
    { headerName: "Type", field: "type", flex: 1 },
    {
      headerName: "Start Date",
      field: "start_date",
      flex: 1,
      valueFormatter: (params) => {
        if (!params.value || params.value === "00/00/0000") return "N/A";
        const [day, month, year] = params.value.split("/");
        const formattedDate = new Date(`${year}-${month}-${day}`);
        return isNaN(formattedDate) ? "Invalid Date" : formattedDate.toLocaleDateString();
      },
    },
    {
      headerName: "End Date",
      field: "end_date",
      flex: 1,
      valueFormatter: (params) => {
        if (!params.value || params.value === "00/00/0000") return "N/A";
        const [day, month, year] = params.value.split("/");
        const formattedDate = new Date(`${year}-${month}-${day}`);
        return isNaN(formattedDate) ? "Invalid Date" : formattedDate.toLocaleDateString();
      },
    },
    { headerName: "Created By", field: "cby", flex: 1 },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <div className="flex space-x-2">
          <button
            onClick={() => handleEditClick(params.data)}
            className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
          >
            Edit
          </button>
          <button
            onClick={() => handleDeleteClick(params.data.id)}
            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="bg-gray-100 min-h-screen p-4">
      <div className="max-w-md mx-auto mt-10 bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl text-blue-700 font-bold mb-6 text-center">Home Slider</h2>
        <form onSubmit={handleSave}>
          <div className="mb-4">
            <label htmlFor="imageUpload" className="block text-gray-700 font-medium mb-2">
              Image Upload:
            </label>
            <input 
              type="file" 
              id="imageUpload"
              accept="image/*"
              onChange={handleImageUpload} 
              className="w-full text-gray-700 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
            {imagePreview && (
              <div className="mt-3">
                <p className="text-gray-600">Current Image:</p>
                <img src={imagePreview} alt="Slider" className="w-32 h-auto mt-2" />
              </div>
            )}
          </div>
          <div className="mb-6">
            <label htmlFor="clickUrl" className="block text-gray-700 font-medium mb-2">
              Click URL:
            </label>
            <input 
              type="text" 
              id="clickUrl"
              required
              value={clickUrl} 
              onChange={handleUrlChange} 
              placeholder="Enter URL" 
              className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 font-medium mb-2">Type:</label>
            <select required value={type} onChange={handleTypeChange} className="w-full p-2 border rounded">
              <option value="">Select Type</option>
              <option value="ஜோதிடர்">ஜோதிடர்</option>
              <option value="ஐயர்">ஐயர்</option>
              <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
              <option value="எண்கணிதம்">எண்கணிதம்</option>
              <option value="சிற்பி">சிற்பி</option>
              <option value="விபூதி தயாரிப்பவர்">விபூதி தயாரிப்பவர்</option>
              <option value="ஆன்மீக சொற்பொழிவாளர்">ஆன்மீக சொற்பொழிவாளர்</option>
              <option value="திருவிழா அலங்காரம் செய்பவர்">திருவிழா அலங்காரம் செய்பவர்</option>
              <option value="சிற்பி / ஸ்தபதி">சிற்பி / ஸ்தபதி</option>
              <option value="அலங்காரம் செய்பவர்">அலங்காரம் செய்பவர்</option>
            </select>
          </div>
          <div className="mb-6">
            <label htmlFor="startDate" className="block text-gray-700 font-medium mb-2">
              Start Date:
            </label>
            <input 
              type="date" 
              id="startDate"
              required
              value={startDate} 
              onChange={handleStartDateChange} 
              onKeyDown={(e) => e.preventDefault()} // Prevent manual input
              onClick={(e) => e.target.showPicker()} // Open date picker when clicking anywhere


              className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
              
            />
          </div>
          <div className="mb-6">
            <label htmlFor="endDate" className="block text-gray-700 font-medium mb-2">
              End Date:
            </label>
            <input 
              type="date" 
              id="endDate"
              required
              value={endDate} 
              onChange={handleEndDateChange} 
              onKeyDown={(e) => e.preventDefault()} // Prevent manual input
              onClick={(e) => e.target.showPicker()} // Open date picker when clicking anywhere


              className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>
          <button 
            type="submit" 
            className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600 transition-colors duration-200"
          >
            Save
          </button>
        </form>
      </div>
      <div className="max-w-5xl mx-auto bg-white shadow-md rounded mt-10 p-6">
        <h2 className="text-blue-700 text-xl font-bold mb-4">Home Slider Records</h2>
        <div className="ag-theme-alpine" style={{ height: 500, width: '100%' }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={{ sortable: true, filter: true, editable: false }}
            pagination={true}
            paginationPageSize={5}
            getRowHeight={() => 60}
          />
        </div>
      </div>
    </div>
  );
};

export default HomeSlider;